import type React from 'react';

import { PetitionStatsContextProvider } from '#src/app/pages/petitionDetails/shared/components';

import { MediaHitsContextProvider } from '../containers/MediaHitsContainerSunrise';
import { ScrollContextProvider } from '../hooks/useScrollToSection';

import { DetailsStateWrapper } from './DetailsStateWrapper';

type Props = Readonly<{
	slug: string;
}>;

export const DetailsWithContext: React.FC<Props> = ({ slug }) => {
	return (
		<PetitionStatsContextProvider slug={slug}>
			<MediaHitsContextProvider>
				<ScrollContextProvider>
					{/*
					 * Sets the default text color so it cascades to all descendant text. The design system's Text
					 * component does not apply a color of its own; it inherits from its parent. Setting it here means
					 * it cascades to all text that doesn't specify a more specific color.
					 */}
					<div className="text-typography-strong">
						<DetailsStateWrapper />
					</div>
				</ScrollContextProvider>
			</MediaHitsContextProvider>
		</PetitionStatsContextProvider>
	);
};
